import Listinga from "../components/Dash/Test/Listing/listinga";
import Nav from "../components/Nav/nav";
import Whatsapp from "../Whatsapp/whatsapp";

const ApplicationsP = () => {
  return (
    <div>
      <Nav />
      <Listinga />
      <Whatsapp />
    </div>
  );
};

export default ApplicationsP;
